import React from 'react'
import { FinancialsGrowthResponseData } from '../Config/types'
import Spinner from './Spinner'
import GrowthRateTable from './GrowthRateTable'
import PlaceholderText from './PlaceholderText'
import { Box } from '@mui/material'
import { TableWrapper, SectionHeader, ContentSection } from './Layout'

interface GrowthContentProps {
  financialsGrowthResponseData: FinancialsGrowthResponseData | null
  loading: boolean
}

export const GrowthContent: React.FC<GrowthContentProps> = ({
  financialsGrowthResponseData,
  loading,
}) => {
  if (loading && !financialsGrowthResponseData) {
    return <Spinner />
  }

  if (financialsGrowthResponseData) {
    return (
      <Box>
        <ContentSection sx={{ mb: { xs: 6, md: 4 } }}>
          <SectionHeader variant="h5" gutterBottom>
            Mean Growth Rate Over Number of Years
          </SectionHeader>
          <TableWrapper>
            <GrowthRateTable 
              data={financialsGrowthResponseData}
              dataField="mean_growth_rate"
              ariaLabel="Mean Growth Rate Over Number of Years Table"
              sortOrder="desc"
            />
          </TableWrapper>
        </ContentSection>
        <Box>
          <SectionHeader variant="h5" gutterBottom>
            Growth Rate by Year
          </SectionHeader>
          <TableWrapper>
            <GrowthRateTable 
              data={financialsGrowthResponseData}
              dataField="growth_rate"
              ariaLabel="Growth Rate by Year Table"
              sortOrder="asc"
            />
          </TableWrapper>
        </Box>
      </Box>
    )
  }

  return <PlaceholderText />
}

export default GrowthContent
